import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ICondoGuestsState {
  adultsCount: number;
  kidsCount: number;
  bedroomsCount: number;
  includeStudio: boolean;
  prevAdultsCount: number;
  prevKidsCount: number;
  prevBedroomsCount: number;
  prevIncludeStudio: boolean;
  error?: string;
}

export const CondoGuestInitialState: ICondoGuestsState = {
  adultsCount: 2,
  kidsCount: 0,
  bedroomsCount: 1,
  includeStudio: true,
  prevAdultsCount: 2,
  prevKidsCount: 0,
  prevBedroomsCount: 1,
  prevIncludeStudio: true,
  error: ''
};

const condoGuestsSlice = createSlice({
  name: 'condo-guests',
  initialState: CondoGuestInitialState,
  reducers: {
    updateAdultsCount: (state: ICondoGuestsState, { payload }: PayloadAction<number>) => {
      state.prevAdultsCount = state.adultsCount;
      state.adultsCount = payload;
    },
    updateKidsCount: (state: ICondoGuestsState, { payload }: PayloadAction<number>) => {
      state.prevKidsCount = state.kidsCount;
      state.kidsCount = payload;
    },
    updateBedroomCount: (state: ICondoGuestsState, { payload }: PayloadAction<number>) => {
      state.prevBedroomsCount = state.bedroomsCount;
      state.bedroomsCount = payload;
    },
    updateIncludeStudio: (state: ICondoGuestsState, { payload }: PayloadAction<boolean>) => {
      state.prevIncludeStudio = state.includeStudio;
      state.includeStudio = payload;
    },
    updateAdultsCountExperiences: (state: ICondoGuestsState, { payload }: PayloadAction<number>) => {
      state.prevAdultsCount = state.adultsCount;
      state.adultsCount = payload;
    },
    updateKidsCountExperiences: (state: ICondoGuestsState, { payload }: PayloadAction<number>) => {
      state.prevKidsCount = state.kidsCount;
      state.kidsCount = payload;
    },
    updateBedroomCountExperiences: (state: ICondoGuestsState, { payload }: PayloadAction<number>) => {
      state.prevBedroomsCount = state.bedroomsCount;
      state.bedroomsCount = payload;
    },
    updateIncludeStudioExperiences: (state: ICondoGuestsState, { payload }: PayloadAction<boolean>) => {
      state.prevIncludeStudio = state.includeStudio;
      state.includeStudio = payload;
    },
    setState: (state, { payload }: PayloadAction<Partial<ICondoGuestsState>>) => {
      return {
        ...state,
        ...payload,
      };
    },
    resetGuest: () => {
      return CondoGuestInitialState;
    },
  },
});

export const { updateAdultsCount, updateKidsCount, updateBedroomCount, updateIncludeStudio, updateAdultsCountExperiences, updateKidsCountExperiences, updateBedroomCountExperiences, updateIncludeStudioExperiences } =
  condoGuestsSlice.actions;

export const condoGuestsActions = condoGuestsSlice.actions;

export const condoGuestsReducer = condoGuestsSlice.reducer;
